import { render, staticRenderFns } from "./AdminDesignatedPosition.vue?vue&type=template&id=046f9152"
import script from "./AdminDesignatedPosition.vue?vue&type=script&lang=js"
export * from "./AdminDesignatedPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports